/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

import { StackProps } from '@mui/material';

export const productCardInventoryStack: StackProps = {
	sx: { minHeight: '5px' },
};
